import axiosInstance from '../../main/axios';
import { toastr } from 'react-redux-toastr';
import { initialize } from 'redux-form';
import { showTabs, selectTab } from '../../common/tab/tabActions';

const INITIAL_VALUES = {
  status: 'INSTALADO',
  grupo_fisico_filtro: '',
};

export { selectTab };

export function getList(params = {}) {
  const request = axiosInstance.get('/manutencao/inventario/equipamentos', { params });
  return { type: 'INVENTARIO_FETCHED', payload: request };
}

export function getOpcoes() {
  const request = axiosInstance.get('/manutencao/inventario/opcoes');
  return { type: 'INVENTARIO_OPCOES_FETCHED', payload: request };
}

export function getTipos() {
  const request = axiosInstance.get('/manutencao/inventario/tipos');
  return { type: 'INVENTARIO_TIPOS_FETCHED', payload: request };
}

export function getCategorias() {
  const request = axiosInstance.get('/manutencao/inventario/categorias');
  return { type: 'INVENTARIO_CATEGORIAS_FETCHED', payload: request };
}

export function getFases(controladorId) {
  if (!controladorId) {
    return { type: 'INVENTARIO_FASES_FETCHED', payload: Promise.resolve({ data: [] }) };
  }
  const request = axiosInstance.get(`/manutencao/controladores/${controladorId}/fases`);
  return { type: 'INVENTARIO_FASES_FETCHED', payload: request };
}

export function getHistorico(equipamentoId) {
  const request = axiosInstance.get(`/manutencao/inventario/equipamentos/${equipamentoId}/historico`);
  return { type: 'INVENTARIO_HISTORICO_FETCHED', payload: request };
}

export const setPaginaAtual = pagina => ({ type: 'INVENTARIO_PAGE', payload: pagina });

function normalizeEquipamento(values) {
  const payload = {
    ...values,
    equipamento_tipo_id: values.equipamento_tipo_id ? parseInt(values.equipamento_tipo_id, 10) : null,
    controlador_id: values.controlador_id ? parseInt(values.controlador_id, 10) : null,
    fase_id: values.fase_id ? parseInt(values.fase_id, 10) : null,
    estoque_item_id: values.estoque_item_id ? parseInt(values.estoque_item_id, 10) : null,
    ordem_servico_instalacao_id: values.ordem_servico_instalacao_id
      ? parseInt(values.ordem_servico_instalacao_id, 10)
      : null,
  };
  delete payload.grupo_fisico_filtro;
  return payload;
}

export function create(values) {
  return submit(normalizeEquipamento(values), 'post');
}

export function update(values) {
  return submit(normalizeEquipamento(values), 'put');
}

export function remove(values) {
  return dispatch => {
    axiosInstance
      .delete(`/manutencao/inventario/equipamentos/${values.id}`)
      .then(() => {
        toastr.success('Sucesso', 'Equipamento excluído.');
        dispatch(init());
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível excluir o equipamento.');
      });
  };
}

export function registrarRemocao(id, dados) {
  return dispatch => {
    axiosInstance
      .post(`/manutencao/inventario/equipamentos/${id}/remover`, dados)
      .then(() => {
        toastr.success('Sucesso', 'Remoção registrada.');
        dispatch(init());
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível registrar a remoção.');
      });
  };
}

export function registrarTroca(id, dados) {
  return dispatch => {
    axiosInstance
      .post(`/manutencao/inventario/equipamentos/${id}/trocar`, dados)
      .then(() => {
        toastr.success('Sucesso', 'Troca registrada com sucesso.');
        dispatch(init());
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível registrar a troca.');
      });
  };
}

function submit(values, method) {
  return dispatch => {
    const id = values.id ? values.id : '';
    const url =
      method === 'put'
        ? `/manutencao/inventario/equipamentos/${id}`
        : '/manutencao/inventario/equipamentos';
    axiosInstance[method](url, values)
      .then(() => {
        toastr.success('Sucesso', 'Operação realizada com sucesso.');
        dispatch(init());
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível salvar o equipamento.');
      });
  };
}

export function createTipo(values) {
  return (dispatch, getState) => {
    axiosInstance
      .post('/manutencao/inventario/tipos', {
        ...values,
        equipamento_categoria_id: values.equipamento_categoria_id
          ? parseInt(values.equipamento_categoria_id, 10)
          : null,
        ativo: values.ativo === undefined || parseInt(values.ativo, 10) === 1,
      })
      .then(() => {
        toastr.success('Sucesso', 'Tipo cadastrado.');
        dispatch(getTipos());
        dispatch(getOpcoes());
        dispatch(resetTipoForm(getState().manutencaoInventario.categorias));
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível salvar o tipo.');
      });
  };
}

export function updateTipo(tipo, values) {
  return (dispatch, getState) => {
    const patch =
      values && values.nome !== undefined
        ? {
            nome: values.nome,
            descricao: values.descricao || null,
            equipamento_categoria_id: values.equipamento_categoria_id
              ? parseInt(values.equipamento_categoria_id, 10)
              : undefined,
          }
        : values;

    axiosInstance
      .put(`/manutencao/inventario/tipos/${tipo.id}`, patch)
      .then(() => {
        toastr.success('Sucesso', 'Tipo atualizado.');
        dispatch(getTipos());
        dispatch(getOpcoes());
        if (values && values.nome !== undefined) {
          dispatch(resetTipoForm(getState().manutencaoInventario.categorias));
        }
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível atualizar o tipo.');
      });
  };
}

function defaultCategoriaId(categorias) {
  const lista = categorias || [];
  const outro = lista.find(c => c.codigo === 'OUTRO');
  if (outro) return String(outro.id);
  const primeiraAtiva = lista.find(c => c.ativo);
  return primeiraAtiva ? String(primeiraAtiva.id) : '';
}

export function resetTipoForm(categoriasOrValues) {
  if (categoriasOrValues && categoriasOrValues.id) {
    return initialize('inventarioTipoForm', {
      id: categoriasOrValues.id,
      nome: categoriasOrValues.nome,
      descricao: categoriasOrValues.descricao || '',
      equipamento_categoria_id: String(categoriasOrValues.equipamento_categoria_id),
      ativo: categoriasOrValues.ativo ? '1' : '0',
    });
  }

  const categorias = Array.isArray(categoriasOrValues) ? categoriasOrValues : undefined;
  return initialize('inventarioTipoForm', {
    equipamento_categoria_id: defaultCategoriaId(categorias),
    ativo: '1',
    nome: '',
    descricao: '',
  });
}

export function createCategoria(values) {
  return dispatch => {
    axiosInstance
      .post('/manutencao/inventario/categorias', {
        nome: values.nome,
        descricao: values.descricao || null,
        badge_class: values.badge_class || 'os-badge--gray',
        ordem: (values.ordem !== null && values.ordem !== undefined) ? parseInt(values.ordem, 10) : 0,
        ativo: true,
      })
      .then(() => {
        toastr.success('Sucesso', 'Categoria cadastrada.');
        dispatch(getCategorias());
        dispatch(getTipos());
        dispatch(getOpcoes());
        dispatch(resetCategoriaForm());
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível salvar a categoria.');
      });
  };
}

export function updateCategoria(categoria, values) {
  return dispatch => {
    const patch =
      values && values.nome !== undefined
        ? {
            nome: values.nome,
            descricao: values.descricao || null,
            badge_class: values.badge_class || 'os-badge--gray',
            ordem: (values.ordem !== null && values.ordem !== undefined) ? parseInt(values.ordem, 10) : 0,
          }
        : values;

    axiosInstance
      .put(`/manutencao/inventario/categorias/${categoria.id}`, patch)
      .then(() => {
        toastr.success('Sucesso', 'Categoria atualizada.');
        dispatch(getCategorias());
        dispatch(getTipos());
        dispatch(getOpcoes());
        if (values && values.nome !== undefined) {
          dispatch(resetCategoriaForm());
        }
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível atualizar a categoria.');
      });
  };
}

export function resetCategoriaForm(values) {
  if (values) {
    return initialize('inventarioCategoriaForm', values);
  }
  return initialize('inventarioCategoriaForm', {
    badge_class: 'os-badge--gray',
    ordem: '0',
    nome: '',
    descricao: '',
  });
}

export function showUpdate(item) {
  return [
    showTabs('tabUpdate', 'tabHistorico', 'tabTrocar'),
    selectTab('tabUpdate'),
    initialize('inventarioForm', formatForForm(item)),
    getFases(item.controlador_id),
    { type: 'INVENTARIO_SELECTED', payload: item },
  ];
}

export function showHistorico(item) {
  return [
    showTabs('tabUpdate', 'tabHistorico', 'tabTrocar'),
    selectTab('tabHistorico'),
    initialize('inventarioForm', formatForForm(item)),
    getHistorico(item.id),
    { type: 'INVENTARIO_SELECTED', payload: item },
  ];
}

export function showTrocar(item) {
  return [
    showTabs('tabUpdate', 'tabHistorico', 'tabTrocar'),
    selectTab('tabTrocar'),
    initialize('inventarioForm', formatForForm(item)),
    { type: 'INVENTARIO_SELECTED', payload: item },
  ];
}

function formatForForm(item) {
  return {
    ...item,
    equipamento_tipo_id: (item.equipamento_tipo_id !== null && item.equipamento_tipo_id !== undefined) ? String(item.equipamento_tipo_id) : '',
    grupo_fisico_filtro: (item.grupo_fisico_id !== null && item.grupo_fisico_id !== undefined) ? String(item.grupo_fisico_id) : '',
    controlador_id: (item.controlador_id !== null && item.controlador_id !== undefined) ? String(item.controlador_id) : '',
    fase_id: (item.fase_id !== null && item.fase_id !== undefined) ? String(item.fase_id) : '',
    estoque_item_id: (item.estoque_item_id !== null && item.estoque_item_id !== undefined) ? String(item.estoque_item_id) : '',
    ordem_servico_instalacao_id:
      (item.ordem_servico_instalacao_id !== null && item.ordem_servico_instalacao_id !== undefined) ? String(item.ordem_servico_instalacao_id) : '',
    data_instalacao: item.data_instalacao ? String(item.data_instalacao).slice(0, 10) : '',
    data_garantia_fim: item.data_garantia_fim ? String(item.data_garantia_fim).slice(0, 10) : '',
  };
}

export function init() {
  return [
    showTabs('tabList', 'tabCreate', 'tabTipos', 'tabCategorias'),
    selectTab('tabList'),
    getList(),
    getOpcoes(),
    getTipos(),
    getCategorias(),
    initialize('inventarioForm', INITIAL_VALUES),
    { type: 'INVENTARIO_SELECTED', payload: null },
    { type: 'INVENTARIO_HISTORICO_FETCHED', payload: { data: [] } },
  ];
}
